import { render, staticRenderFns } from "./CommodityBuyModal.vue?vue&type=template&id=501c3aef&scoped=true&"
import script from "./CommodityBuyModal.vue?vue&type=script&lang=js&"
export * from "./CommodityBuyModal.vue?vue&type=script&lang=js&"
import style0 from "./CommodityBuyModal.vue?vue&type=style&index=0&id=501c3aef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c3aef",
  null
  
)

export default component.exports